var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1593_71626)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.68629 0 4 2.68629 4 6V34C4 37.3137 6.68629 40 10 40H38C41.3137 40 44 37.3137 44 34V22.8448C43.9118 22.853 43.8225 22.8571 43.7321 22.8571C42.1542 22.8571 40.875 21.578 40.875 20C40.875 18.422 42.1542 17.1429 43.7321 17.1429C43.8225 17.1429 43.9118 17.147 44 17.1552V6C44 2.68629 41.3137 0 38 0H10Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0808 18.9352V22.5766H35.3897V18.9352C35.3897 18.4758 35.0158 18.1016 34.5561 18.1016H32.8383L20.9143 18.1018C20.4549 18.1018 20.0808 18.4758 20.0808 18.9352ZM31.1761 19.336C31.1761 19.2421 31.2523 19.1659 31.3463 19.1659H33.754C33.848 19.1659 33.9241 19.2421 33.9241 19.336V21.7437C33.9241 21.8377 33.848 21.9139 33.754 21.9139H31.3463C31.2523 21.9139 31.1761 21.8377 31.1761 21.7437V19.336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.978 22.0688V20.1421H11.4001L12.8057 20.8991L14.978 22.0688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0808 22.9165H35.3897V23.9806H20.0808V22.9165Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.73 20.9896V26.5591C35.73 27.2062 35.2034 27.7326 34.5563 27.7326L20.9144 27.7323C20.2672 27.7323 19.7407 27.206 19.7407 26.5589V25.0207L10.8955 20.2573V34.0906H37.0908L37.091 20.2573L35.73 20.9896Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0808 24.9188V26.5586C20.0808 27.018 20.4548 27.3918 20.9145 27.3918H34.5564C35.0159 27.3918 35.3901 27.018 35.3901 26.5586V24.3208H20.0812L20.0808 24.9188ZM31.3705 24.9836C31.5257 24.9836 31.6779 25.0254 31.81 25.103C31.9413 25.0256 32.0931 24.9836 32.2488 24.9836C32.7298 24.9836 33.1211 25.3749 33.1211 25.8559C33.1211 26.3369 32.7298 26.7282 32.2488 26.7282C32.0929 26.7282 31.9413 26.6864 31.81 26.6089C31.6779 26.6862 31.5257 26.7282 31.3705 26.7282C30.8895 26.7282 30.4982 26.3369 30.4982 25.8559C30.4982 25.3749 30.8895 24.9836 31.3705 24.9836Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7407 24.634V18.935C19.7407 18.2878 20.2673 17.7613 20.9144 17.7613H32.6682V7.89551H15.3181V22.2525L17.6328 23.4991L19.7407 24.634ZM30.1167 15.7202H17.8696C17.7756 15.7202 17.6995 15.644 17.6995 15.55C17.6995 15.4561 17.7756 15.3799 17.8696 15.3799H30.1167C30.2107 15.3799 30.2869 15.4561 30.2869 15.55C30.2869 15.6443 30.2107 15.7202 30.1167 15.7202ZM30.1167 14.0192H17.8696C17.7756 14.0192 17.6995 13.943 17.6995 13.8491C17.6995 13.7551 17.7756 13.6789 17.8696 13.6789H30.1167C30.2107 13.6789 30.2869 13.7551 30.2869 13.8491C30.2869 13.9433 30.2107 14.0192 30.1167 14.0192ZM21.952 10.9575H30.1167C30.2107 10.9575 30.2869 11.0337 30.2869 11.1277C30.2869 11.2217 30.2107 11.2978 30.1167 11.2978H21.952C21.858 11.2978 21.7818 11.2217 21.7818 11.1277C21.7818 11.0337 21.8578 10.9575 21.952 10.9575ZM17.8061 10.0456C18.1003 9.75558 18.4848 9.59682 18.8901 9.59682C19.2954 9.59682 19.6798 9.75558 19.9722 10.0437C20.2621 10.3379 20.4209 10.7224 20.4209 11.1277C20.4209 11.533 20.2621 11.9174 19.974 12.2098C19.9733 12.2105 19.9726 12.2112 19.9721 12.2117C19.6798 12.4997 19.2953 12.6585 18.8901 12.6585C18.046 12.6585 17.3592 11.9717 17.3592 11.1277C17.3592 10.7224 17.518 10.3379 17.8061 10.0456Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1593_71626",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1593_71626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1593_71626",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillOn);
export default __webpack_public_path__ + "static/media/BillOn.fa21e47a87fb6e53b17c8bf1a24c2e68.svg";
export { ForwardRef as ReactComponent };